import request from '@/utils/request';

//权限授权列表
export function getAuthList(values) {
  return request('/wechat/queryWechatAccountAuthPage', {
    method: 'POST',
    data: values,
  });
}
// 绑定账号
export function getAuthBind() {
  return request('/wechat/account/authQrCod', {
    // return request('/wxPlatform/auth/componentLoginPage', {
    method: 'POST',
    // method: 'GET',
    // data: values,
  });
}
